<template>
  <div :class="[_.item, selected && _.selected]" @click="handleItemClick()">
    <div :class="[_.hd, _._hairlineBottom]">
      <div :class="_.name">{{ item.selfPickupName }}</div>
      <div
        v-if="!noDistance && item.distanceDesc && item.distanceDesc !== '未知'"
        :class="_.distance"
      >
        {{ item.distanceDesc }}
      </div>
    </div>
    <div :class="_.bd">
      <div :class="_.content">
        <div :class="_.address">
          {{
            `${item.provinceName || item.province}${
              item.cityName || item.city
            }${item.countyName || item.area}${
              item.detailedAddress || item.detail
            }`
          }}
        </div>
        <div :class="_.extra">
          <div>
            营业时间
            {{
              item.businessTimeStr ||
              `${item.businessStartTime || ''}-${item.businessEndTime || ''}`
            }}
          </div>
          <div>联系方式 {{ item.contactTel || item.phoneNo }}</div>
        </div>
      </div>
      <img
        v-if="item.longitude && item.latitude"
        src="./images/导航.png"
        :class="_.navigate"
        @click.stop="handleNavigateClick(item)"
      />
    </div>
  </div>
</template>

<script>
  import { openMap } from '@/utils'

  export default {
    props: {
      item: Object,
      selected: Boolean,
      noDistance: Boolean,
    },
    methods: {
      handleItemClick() {
        this.$emit('click')
      },
      handleNavigateClick() {
        openMap({
          name: this.item.selfPickupName,
          latitude: this.item.latitude,
          longitude: this.item.longitude,
        })
      },
    },
  }
</script>

<style lang="scss" module>
  .item {
    position: relative;
    background: #ffffff;
    border-radius: 8px;
    padding: 12px;
    overflow: hidden;

    .hd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 12px;

      .name {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        font-style: normal;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .distance {
        flex-shrink: 0;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        font-style: normal;
      }
    }

    .bd {
      margin-top: 6px;
      display: flex;
      align-items: center;

      .content {
        flex-grow: 1;

        .address {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #666666;
          line-height: 20px;
          font-style: normal;
        }

        .extra {
          margin-top: 4px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #999999;
          line-height: 20px;
          font-style: normal;
        }
      }

      .navigate {
        flex-shrink: 0;
        width: 27px;
        height: 27px;

        &:active {
          filter: contrast(0.9) opacity(0.9);
        }
      }
    }

    &.selected {
      border: 1px solid #ff171e;

      &::after {
        content: '';
        position: absolute;
        right: -2px;
        bottom: -2px;
        width: 25px;
        height: 25px;
        background-image: url('./images/选中.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
      }
    }

    + .item {
      margin-top: 12px;
    }
  }
</style>
